import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import classes from "./BotTypingLoader.module.css";
import src from "./typingLottie.json?url";

function BotTypingLoader() {
    return <DotLottieReact src={src} className={classes.player} loop autoplay speed={1} />;
}
export default BotTypingLoader;
